// Password generation constants
export const PASSWORD_CHARSET =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=[]{}|;:,.<>?';

export const DEFAULT_PASSWORD_LENGTH = 256;

/**
 * Generates a cryptographically secure password
 * @param length - The desired length of the password (default: DEFAULT_PASSWORD_LENGTH)
 * @returns A secure random password string
 */
export const generateSecurePassword = (
  length: number = DEFAULT_PASSWORD_LENGTH
): string => {
  const passwordArray = new Uint8Array(length);
  crypto.getRandomValues(passwordArray);

  return Array.from(passwordArray)
    .map(byte => PASSWORD_CHARSET[byte % PASSWORD_CHARSET.length])
    .join('');
};
